import { Building2, MapPin } from "lucide-react";
import { Link } from "react-router";
import { companyPath } from "~/lib/company-profile";
import type { RelatedCompaniesResponse, RelatedCompanyEntry } from "~/types/company";
import { OverviewCard } from "./card";

function RelatedCompanyList({ entries }: { entries: RelatedCompanyEntry[] }) {
	return (
		<ul className="flex flex-col gap-2">
			{entries.map((entry) => (
				<li key={entry.ico} className="flex items-baseline justify-between gap-3 text-sm">
					<Link
						to={companyPath(entry.ico, entry.name)}
						prefetch="intent"
						className="min-w-0 flex-1 truncate font-medium text-primary hover:underline"
					>
						{entry.name}
					</Link>
					{entry.city && (
						<span className="shrink-0 text-xs text-muted-foreground">{entry.city}</span>
					)}
				</li>
			))}
		</ul>
	);
}

/** ⑪ SEO blocks — Podobné firmy + Firmy na stejné adrese (internal-link mesh).
 * Hidden entirely when the related fetch failed or both lists are empty. */
export function RelatedCompaniesCards({ related }: { related: RelatedCompaniesResponse | null }) {
	if (!related) return null;

	const hasSimilar = related.similarByName.length > 0;
	const hasAtAddress = related.atAddress.length > 0;
	if (!hasSimilar && !hasAtAddress) return null;

	return (
		<div className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:items-start">
			{hasSimilar && (
				<OverviewCard icon={Building2} title="Podobné firmy">
					<RelatedCompanyList entries={related.similarByName} />
				</OverviewCard>
			)}
			{hasAtAddress && (
				<OverviewCard icon={MapPin} title="Firmy na stejné adrese">
					<RelatedCompanyList entries={related.atAddress} />
				</OverviewCard>
			)}
		</div>
	);
}
